import { DOCUMENT, inject, Injectable, InjectionToken, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

function mockLocalStorage(): Storage {
  return {
    length: 0,
    key: () => null,
    getItem: () => null,
    setItem: () => null,
    removeItem: () => null,
    clear: () => null,
  };
}

export const LOCAL_STORAGE_TOKEN = new InjectionToken<Storage>(
  'LOCAL_STORAGE_TOKEN',
  {
    factory: (): Storage => {
      const platformId = inject(PLATFORM_ID);
      const document = inject(DOCUMENT);
      const isBrowser = isPlatformBrowser(platformId);

      if (isBrowser) {
        return document.defaultView?.localStorage ?? mockLocalStorage();
      } else {
        return mockLocalStorage();
      }
    },
  }
);

@Injectable({
  providedIn: 'root',
})
export class LocalStorageService implements Storage {
  private storage = inject(LOCAL_STORAGE_TOKEN);

  get length(): number {
    return this.storage.length;
  }

  // eslint-disable-next-line
  setItem(key: string, value: any): void {
    this.storage.setItem(key, JSON.stringify(value));
  }

  getItem<T>(key: string): T | null {
    const data = this.storage.getItem(key);
    if (!data) {
      return null;
    }

    return JSON.parse(data);
  }

  removeItem(key: string): void {
    this.storage.removeItem(key);
  }

  hasKey(key: string): boolean {
    return this.storage.getItem(key) !== null;
  }

  key(index: number): string | null {
    return this.storage.key(index);
  }

  clear(): void {
    this.storage.clear();
  }
}
